import React, { useState, useEffect } from 'react';
import './Sample.css';
import SampleManager from '../SampleManager/SampleManager';
import Validate from '../SampleManager/Validate';
import Inventory from './RV/Inventory';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';

function Sample({ user }) {
    const [activeTab, setActiveTab] = useState('calendar');
    const [samples, setSamples] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);



    return (
        <div className="HomeSample">
            <div className="HomeSample-header">
                <div className="HomeSample-tabs">
                    <button 
                        className={`HomeSample-tab ${activeTab === 'calendar' ? 'active' : ''}`}
                        onClick={() => setActiveTab('calendar')}
                    >
                        <span>Orders</span>
                    </button>
                    <button 
                        className={`HomeSample-tab ${activeTab === 'inventory' ? 'active' : ''}`}
                        onClick={() => setActiveTab('inventory')}
                    >
                        <span>Units</span>
                    </button>
            <button 
                        className={`HomeSample-tab ${activeTab === 'shop' ? 'active' : ''}`}
                        onClick={() => setActiveTab('shop')}
                    >
                        <span>Shop</span>
                    </button>
           
       
                </div>
            </div>
            <div className="HomeSample-content">
                {activeTab === 'calendar' && <SampleManager user={user} />}
                {activeTab === 'validate' && <Validate user={user} samples={samples} />}
                {activeTab === 'inventory' && <Inventory user={user}/>}
            </div>
        </div>
    );
}

export default Sample;
